import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "../../Button";
import Modal from "../../Modal";

const ProjectGoal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [projectData, setProjectData] = useState(null);

  useImperativeHandle(ref, () => ({
    openModal(projectData) {
      setProjectData(projectData);
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  function formatProjectGoal(goal) {
    if (!goal) return "";

    const lines = goal.split(/\r?\n/);
    let count = 1;

    const formattedLines = lines.map((line) => {
      if (line.trim().startsWith("•")) {
        return `<strong>${count++}.</strong> ${line.replace("•", "").trim()}`;
      }
      return line;
    });

    return formattedLines.join("<br>");
  }

  return (
    <Modal
      footer={
        <div className="flex justify-end">
          <Button color="white" variant="outlined" onClick={handleCloseModal} label={t("close")} />
        </div>
      }
      header={
        <h2 className="text-2xl font-semibold text-blue-500">{projectData?.name || t("project_name")}</h2>
      }
      isOpen={isOpen}
      onClose={handleCloseModal}
    >
      <div className="space-y-6 p-6">
        <div className="space-y-4">
          {/* Project Image */}
          {projectData?.image && (
            <div className="flex justify-center">
              <img
                src={projectData.image}
                alt={projectData.name}
                className="h-80 w-full rounded-lg shadow-md"
              />
            </div>
          )}

          <div
            className="text-lg leading-relaxed text-gray-700"
            dangerouslySetInnerHTML={{
              __html: formatProjectGoal(projectData?.projectGoal || t("no_project_goal")),
            }}
          />
        </div>
      </div>
    </Modal>
  );
});

export default ProjectGoal;
